module.exports = __webpack_public_path__ + "static_1764244025768/img/openup_new.61d1c43f.png";